import React, {Component} from "react";

import {
    Image,
    Platform,
    StyleSheet,
    TouchableHighlight, TouchableOpacity, ActivityIndicator, Alert, PermissionsAndroid,
    FlatList,
    View
} from "react-native";


import HMTextView from "../customviews/HMTextView";
import store from "../redux/store";

import i18n from './../I18n/i18n.js';
import * as Colors from "../tools/Colors";
import {moderateScale} from "../tools/Scaling";
import PathFile from "../assets/PathFile";
import wifi from "../importCalss/wifi";

// import {serviceActionSetIsConnected} from "../redux/actions/ActionSplashGetAllData";
import {connect} from "react-redux";
import axios from "axios";
import {
    serviceActionSetConnectionInternetHotspot,
    serviceActionSetwifiConnectionStatus,
    serviceActionSetwifiIsEnabled
} from "../screens/satia/splash/action/ActionSplashSatiaScreen";
import {AsyngStorageClass} from "../tools/AsyngStorageClass";
import {typeExport} from "../redux/store/type";
import HMTextInput from "./HMTextInput";
import Geolocation from "react-native-geolocation-service";
import AndroidOpenSettings from "../importCalss/AndroidOpenSettings/index.ios";
import HMAlert from "./HMAlert";
import Toast from "./toast";

let content = null;
//let NameHotspot = "PS-net-satia";
let NameHotspot = "Satia";

//let chechVersion = false;
//let DataSplashScreen = null;
//let chechVersion_force = null;

let time = 3000

class HMDialogWifiCheck extends Component {

    constructor(props) {
        super(props);
        content = this;

        this.state = {
            userWifi: props.DataSplashScreen.userWifi,
            passWifi: props.DataSplashScreen.passWifi,

            showDialog: true,
            wifiIsEnabled: false,
            wifiConnectionStatus: false,
            wifiConnectionSatia: false,
            wifiConnectionGoogle: false,
            listSearch: [],
            loadingSearchWifi: false,
            textSearch: 'لطفا صبر نمایید ... ',
            accessSearchWifi: true,
            isLoading: false,
            NameHotspot: NameHotspot,
        }
        //this.searchListWifi=   this.searchListWifi().bind(this)
        // try {
        //     this.checkSatusWifi()
        //
        // }
        // catch (e) {
        //     alert("kikkkk")
        // }


    }

    async componentWillMount() {
        //  let storage = await AsyngStorageClass.getASyng(typeExport._UserPassWifi);


        /*    this.setState({
                // userWifi: storage ? storage.userWifi : null,
                // passWifi: storage ? storage.passWifi : null,
                userWifi: this.props.DataSplashScreen.userWifi,
                passWifi: this.props.DataSplashScreen.passWifi,
            })*/
    }

    async componentDidMount() {
        // await AsyngStorageClass.setAsyng(typeExport._UserPassWifi, null);
        this.requestLogin();

        if (this.props.wifiIsEnabled && !this.props.wifiConnectionStatus) {
            this.searchListWifi()
        }
    }

    //
    // checkSatusWifi() {
    //     wifi.isEnabled((isEnabled) => {
    //         if (isEnabled) {
    //             this.setState({wifiIsEnabled: true})
    //             console.log("**wifi service enabled");
    //             wifi.connectionStatus((isConnected) => {
    //                 if (isConnected) {
    //                     this.setState({wifiConnectionStatus: true})
    //
    //                     console.log("**is connected");
    //                 } else {
    //                     this.setState({wifiConnectionStatus: false})
    //                     this.searchListWifi()
    //
    //                     console.log("**is not connected");
    //                 }
    //             });
    //         } else {
    //             this.setState({wifiIsEnabled: false})
    //             console.log("**wifi service is disabled");
    //         }
    //     });
    //
    // }
    connectionGoogle(func) {
        axios(
            {
                //    url: `http://h.1547.ir/login?username=091895610009&password=863265`,
                //  url: `http://h.1547.ir/login?username=09189648119&password=13981398`,
                url: `https://google.com`,
                method: "GET",
                timeout: 3000,
                headers: {
                    'Content-Type': 'text/html',
                },
            })
            .then(async response => {
                // console.log("response", response);
                let data = response.data;

                content.setState({
                    isConnectionGoogle: response && response.status === 200,

                },)
                if (response && response.status === 200 && func) {
                    func()
                }
            })
            .catch((e) => {
                content.setState({
                    isConnectionGoogle: false,
                    // wifiConnectionStatus: true,

                })
                console.log("errorrequestLogin", e);
            })
    }

    async onWifi() {
        wifi.setEnabled(true);
        store.dispatch(serviceActionSetwifiIsEnabled(true))
        // const granted = await PermissionsAndroid.request(
        //     PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
        //     {
        //         title: 'Location permission is required for WiFi connections',
        //         message:
        //             'This app needs location permission as this is required  ' +
        //             'to scan for wifi networks.',
        //         buttonNegative: 'DENY',
        //         buttonPositive: 'ALLOW',
        //     },
        // );
        //
        // if (granted === PermissionsAndroid.RESULTS.GRANTED) {
        //     wifi.setEnabled(true);
        //     store.dispatch(serviceActionSetwifiIsEnabled(true))
        //
        //     this.setState({
        //             //   wifiIsEnabled: true,
        //             isLoading: true,
        //         },
        //         () => {
        //
        //
        //         }
        //     )
        setTimeout(function () {
                // this.setState({
                //     isLoading: false,
                // })
                // let content2 = this;
                // content.ConnectWifiSSID(content2)
                /*POST request is done here*/
                this.searchListWifi()

            }.bind(this), 2000
        );
        //
        // } else {
        //     // Permission denied
        // }
    }

    async searchListWifi() {
        const granted = await PermissionsAndroid.request(
            PermissionsAndroid.PERMISSIONS.ACCESS_FINE_LOCATION,
            {
                title: 'Location permission is required for WiFi connections',
                message:
                    'This app needs location permission as this is required  ' +
                    'to scan for wifi networks.',
                buttonNegative: 'DENY',
                buttonPositive: 'ALLOW',
            },
        );

        if (granted === PermissionsAndroid.RESULTS.GRANTED) {
            this.setState({
                    //   wifiIsEnabled: true,
                    isLoading: true,
                },
                () => {


                }
            )
            Geolocation.getCurrentPosition(
                (position) => {


                    this.setState(
                        {
                            loadingSearchWifi: true,
                            textSearch: 'لطفا صبر نمایید ... '

                        },
                    )
                    wifi.reScanAndLoadWifiList((wifiStringList) => {
                        var wifiArray = JSON.parse(wifiStringList);

                        this.setState({listSearch: wifiArray},
                            () => {
                                //
                                //
                                // alert(this.state.listSearch.length)
                            }
                        )

                        //  let l = wifiArray.map(obj => obj.SSID == 'bbb')
                        let l = wifiArray.find(obj => obj.SSID == this.state.NameHotspot)
                        //l ? null : this.props.onPressCancel();

                        this.setState(
                            {
                                isLoading: false,
                                //showDialog:l,
                                loadingSearchWifi: false,
                                accessSearchWifi: l ? l : null,
                                textSearch: l ? "برای استفاده از خدمات ساتیا به هات اسپات ساتیا وصل شوید؟" : `هات اسپات ${this.state.NameHotspot} برای اتصال وجود ندارد`

                            }
                        )
                    }, (error) => {
                        this.setState({
                            textSearch: "خطایی رخ داده",
                            loadingSearchWifi: false,
                            isLoading: false,

                        })
                        console.log(error);
                    });
                },
                (error) => {
                    this.setState({
                        textSearch: "دسترسی به موقعیت مکانی شما امکان پذیر نیست",

                        loadingSearchWifi: false,
                        isLoading: false,

                    })
                    if (error.code == 2 && Platform.OS === 'android')
                        AndroidOpenSettings.locationSourceSettings()
                    else {

                        alert("دسترسی به موقعیت مکانی شما امکان پذیر نیست")
                    }
                }
            )
        } else {
            // Permission denied
        }
    }


    async ConnectWifiSSIDInternet(ctx) {

        //   let context = ctx ? ctx : content
        let context = this;
        wifi.getSSID((ssid) => {
            //  console.log(ssid);


            if (ssid == context.state.NameHotspot) {
                context.requestLogin()
                store.dispatch(serviceActionSetwifiConnectionStatus(true))

                // content.setState({
                //     wifiConnectionStatus: true,
                //
                // })

                context.props.func ? context.props.func() : null
            }
            else {
                setTimeout(function () {

                    wifi.findAndConnect(context.state.NameHotspot, null, (found) => {

                        if (found) {
                            context.setState({
                                isLoading: true,

                            })
                            setTimeout(function () {

                                context.requestLogin()

                                context.setState({
                                    isLoading: false,
                                    wifiConnectionStatus: true,

                                })

                                context.props.func ? context.props.func() : null
                                //  content.getData()
                                /*POST request is done here*/
                            }.bind(this), 5000);

                            //  this.getData()
                        } else {
                            context.searchListWifi();
                            context.setState({
                                isLoading: false,

                            })

                            console.log("wifi is not in range");
                        }
                    });
                }.bind(this), 2000);

            }
        });

    }

    requestLogin(checkAlert) {

        if (this.props.wifiIsEnabled && this.props.wifiConnectionStatus) {
            this.setState({
                isLoading: true,

            })
            axios(
                {
                    //    url: `http://h.1547.ir/login?username=09189561009&password=863265`,
                    //  url: `http://h.1547.ir/login?username=09189648119&password=13981398`,
                    //  url: `http://h.1547.ir/login?username=09189557467&password=996633`,
                    url: `http://h.1547.ir/login?username=${this.state.userWifi}&password=${this.state.passWifi}`,
                    method: "GET",
                    timeout: 2000,
                    headers: {
                        'Content-Type': 'text/html',
                    },
                })
                .then(async response => {
                    let data = response.data;
                    let check = (response.data.search("Thank You You Already Login") >= 0);
                    store.dispatch(serviceActionSetConnectionInternetHotspot(check))

                    if (check || check === 0) {
                        Toast.show({
                            // type: 'success | error | info',
                            type: 'custom_info',
                            //  type: data.status ? 'custom_success' : 'custom_error',
                            //  position: 'top | bottom',
                            position: 'top',
                            text1: i18n.t('constant.message'),
                            text2: "شما به هات اسپات " + this.state.NameHotspot + " متصل شدید",
                            visibilityTime: 5000,
                            autoHide: true,
                            //  topOffset: 30,
                            // bottomOffset: 40,
                            onShow: () => {
                            },
                            onHide: () => {
                            }
                        })
                        this.props.onPressCancel ? this.props.onPressCancel() : null
                    }
                    this.setState({
                        isLoading: false,


                    })
                    if (!check && checkAlert) {
                        HMAlert(i18n.t('constant.message'), "نام کاربری یا رمز عبور اشتباه است", [
                                // {text: 'Ask me later', onPress: () => {}},
                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {
                                    }
                                },
                            ],
                            {cancelable: true}
                        )
                    }
                    // alert(response.status)
                })
                .catch((e) => {
                    this.searchListWifi()
                    this.setState({
                        isLoading: false,
                        // wifiConnectionStatus: true,

                    })
                    console.log("errorrequestLogin", e);
                })
        }

    }

    ConnectWifiSSID(content2) {
        let context = content2 ? content2 : content


        wifi.connectionStatus((isConnected) => {


            if (isConnected) {

                // content.setState({
                //     wifiConnectionStatus: true,
                // })

                context.requestLogin()


                console.log("is connected");
            } else {
                context.ConnectWifiSSIDInternet(context)
                // context.searchListWifi()
                // Alert.alert(
                //     i18n.t('constant.message'),
                //     "آیا میخواهید وای  خود را روشن نمایید",
                //     [
                //         // {text: 'Ask me later', onPress: () => {}},
                //         {
                //             text: i18n.t('constant.ok'), onPress: () => {
                //
                //
                //                 Alert.alert(
                //                     i18n.t('constant.message'),
                //                     "آیا میخواهید به هات اسپات ساتیا وصل بشوید",
                //                     [
                //                         // {text: 'Ask me later', onPress: () => {}},
                //                         {
                //                             text: i18n.t('constant.ok'), onPress: async () => {

                //
                //                             }
                //
                //                             , style: 'cancel'
                //                         },
                //
                //                     ],
                //                     {cancelable: true}
                //                 )
                //             }
                //             //  NavigationService.navigatereset("ApplyScreen",{item: item})
                //
                //             , style: 'cancel'
                //         },
                //
                //     ],
                //     {cancelable: true}
                // )

                console.log("is not connected");
            }


        });


    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        // this.setState = (state,callback)=>{
        //     return;
        // };
    }

    render() {
        const {selfStyle, titlee, textt, onPressCancel, onPressOK, numberOfLines, data} = this.props;

        let checkConnectionType = this.props.ConnectionType && this.props.ConnectionType.type ? this.props.ConnectionType.type != 'cellular' : true
        return (

            //  this.state.showDialog && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus) ?
            //    this.state.showDialog && !(this.props.wifiIsEnabled && this.props.wifiConnectionStatus && this.props.ConnectionInternetHotspot) && Platform.OS === "android" && checkConnectionType ?
            //(this.props.ConnectionType && this.props.ConnectionType.type != 'cellular')
            //  this.state.showDialog && Platform.OS==='android' ?
            <View
                style={{
                    position: 'absolute', top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    zIndex: 99999
                }}>
                <TouchableHighlight
                    disabled={true}
                    style={[

                        {
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',

                            // height:"100%",
                            // width:"100%",

                            top: 0,
                            bottom: 0,
                            right: 0,
                            left: 0,
                            backgroundColor: 'rgba(0,0,0,0.7)',
                            // zIndex: 9900
                        }

                    ]} onPress={() => {

                    // this.setState({
                    //     showDialog: false
                    // })
                }}>
                    <View/>

                </TouchableHighlight>

                <View style={{
                    flex: 1,

                    alignItems: 'center',
                    justifyContent: 'center'
                }}>

                    {
                        <View
                            style={{
                                // flex: 1,
                                // justifyContent: "center",
                                // alignItems: "center",
                                backgroundColor: Colors.white,
                                width: '96%',
                                padding: moderateScale(8)
                            }}>
                            <Image style={[{
                                marginHorizontal: moderateScale(10),
                                height: moderateScale(100),
                                width: moderateScale(100),
                                marginVertical: moderateScale(15),
                                alignSelf: 'center',


                            },
                                //  this.state.accessSearchWifi ? {} : {tintColor: Colors.red}
                            ]}
                                //  source={this.state.accessSearchWifi ? PathFile.image.logo : PathFile.image.no_wifi}
                                   source={PathFile.image.logo}
                            />
                            <View/>
                            {
                                this.props.wifiIsEnabled && this.props.wifiConnectionStatus && !this.props.ConnectionInternetHotspot ?
                                    <View>


                                        <HMTextView
                                            type={'bold'}
                                            style={{
                                                fontSize: moderateScale(14),
                                                color: Colors.blackLight,
                                                marginVertical: moderateScale(16),
                                            }}
                                            styleRoot={{alignSelf: 'center'}}
                                            text={"نام کاربری و رمز عبور هات اسپات را وارد نمایید"}
                                            //text={global.MyVar}
                                        />

                                        <View
                                            style={{
                                                // flex: 1,
                                                // justifyContent: "center",
                                                // alignItems: "center",
                                                backgroundColor: Colors.white,
                                                width: '96%',
                                                padding: moderateScale(8)
                                            }}>

                                            <HMTextInput
                                               // _ref={(ref) => this.valueRefUsername = ref}
                                                onRef={(ref) => {
                                                    this.valueRefUsername = ref?.textInput
                                                }}
                                                // style={{height: moderateScale(40),
                                                //     borderColor: 'gray',
                                                //     borderWidth: moderateScale(1),

                                                //
                                                // }}
                                                title={'نام کاربری'}
                                                placeholder={'نام کاربری را وارد نمایید'}


                                                styleTitle={{color: Colors.blackLight}}
                                                onChangeText={text => this.onChangeText("userWifi", text)}
                                                onSubmitEditing={() => {
                                                    // this.checkMobile(this.state.mobile)
                                                }}
                                                // onPressClear={() => this.onChangeText("value", null)}
                                                onPressClear={() => {
                                                    this.onChangeText("userWifi", null)
                                                    this.valueRefUsername.clear()
                                                }}
                                                value={this.state.userWifi}
                                                keyboardType="numeric"
                                            />

                                            <HMTextInput
                                                _ref={(ref) => this.valueRefPassword = ref}

                                                // style={{height: moderateScale(40),
                                                //     borderColor: 'gray',
                                                //     borderWidth: moderateScale(1),

                                                //
                                                // }}
                                                title={'رمز عبور'}
                                                //   placeholder={'constant.PH_phoneNumber'}
                                                placeholder={'رمز عبور را وارد نمایید'}


                                                styleTitle={{color: Colors.blackLight}}
                                                onChangeText={text => this.onChangeText("passWifi", text)}
                                                onSubmitEditing={() => {
                                                    //this.checkMobile(this.state.mobile)
                                                }}
                                                // onPressClear={() => this.onChangeText("value", null)}
                                                onPressClear={() => {
                                                    this.onChangeText("passWifi", null)
                                                    this.valueRefPassword.clear()
                                                }}
                                                value={this.state.passWifi}
                                                keyboardType="numeric"
                                                secureTextEntry={true}
                                            />


                                        </View>

                                        {

                                            <View
                                                style={{
                                                    width: '100%',
                                                    height: moderateScale(42),
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginBottom: moderateScale(3)
                                                }}
                                            >


                                                <TouchableOpacity

                                                    onPress={async () => {
                                                        // this.setState({
                                                        //         userWifi: null,
                                                        //         passWifi: null,
                                                        // },
                                                        //     ()=>{
                                                        //
                                                        //     }
                                                        // )
                                                        await AsyngStorageClass.setAsyng(typeExport._UserPassWifi, {
                                                            userWifi: this.state.userWifi,
                                                            passWifi: this.state.passWifi,
                                                        });


                                                        this.requestLogin(true)

                                                    }}
                                                    style={{
                                                        flex: 1,
                                                        height: moderateScale(42),
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: Colors.colorPrimary,
                                                        borderRadius: moderateScale(6)
                                                    }}>
                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        text={i18n.t('constant.ok')} type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            marginVertical: moderateScale(6),
                                                            marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>
                                                </TouchableOpacity>


                                                <View style={{width: moderateScale(8)}}/>
                                                <TouchableOpacity
                                                    onPress={
                                                        onPressCancel
                                                        // () => {
                                                        //     onPressCancel()
                                                        //     this.setState({
                                                        //         showDialog: false
                                                        //     })
                                                        // }
                                                        //this.props.onPressCancel
                                                        // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                                        //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                                        //this.goBack();

                                                        //this.setState({showDialog: false})
                                                        //console.log(this.state)
                                                    }
                                                    style={{
                                                        flex: 1,
                                                        height: moderateScale(42),
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: Colors.colorPrimary,
                                                        borderRadius: moderateScale(6)

                                                    }}>

                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        text={i18n.t('constant.Cancel')} type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            marginVertical: moderateScale(6),
                                                            marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>
                                                </TouchableOpacity>
                                            </View>

                                        }


                                    </View>
                                    :
                                    // this.props.wifiIsEnabled && !this.props.wifiConnectionStatus && !this.props.ConnectionInternetHotspot ?
                                    //     <View>
                                    //
                                    //
                                    //         <HMTextView
                                    //             type={'bold'}
                                    //             style={{
                                    //                 fontSize: moderateScale(14),
                                    //                 color: Colors.blackLight,
                                    //                 marginVertical: moderateScale(16),
                                    //             }}
                                    //             styleRoot={{alignSelf: 'center'}}
                                    //             text={"یکی از هات اسپات های موجود را انتخاب نمایید"}
                                    //             //text={global.MyVar}
                                    //         />
                                    //
                                    //         {
                                    //
                                    //             (this.state.loadingSearchWifi ?
                                    //                     <ActivityIndicator color={Colors.colorPrimary}
                                    //                                        size={"large"}/>
                                    //                     :
                                    //
                                    //
                                    //                     <FlatList
                                    //                         keyboardShouldPersistTaps="handled"
                                    //                         // ItemSeparatorComponent={
                                    //                         //     <View style={{
                                    //                         //         width: '100%',
                                    //                         //         height: moderateScale(1),
                                    //                         //         backgroundColor: '#4f4f4f'
                                    //                         //     }}/>
                                    //                         // }
                                    //
                                    //                         style={{
                                    //                             height: typeExport._WIDTH / 2,
                                    //                             //  backgroundColor: Colors.light2,
                                    //                             //   marginBottom: moderateScale(50)
                                    //                         }}
                                    //
                                    //                         data={this.state.listSearch}
                                    //                         //data={[1,2,3,4]}
                                    //                         //data={dataList}
                                    //                         keyExtractor={(item, index) => item.id}
                                    //
                                    //                         renderItem={({item, index}) =>
                                    //                             <View style={{}}>
                                    //                                 {
                                    //
                                    //                                     <TouchableOpacity
                                    //                                         activeOpacity={.9}
                                    //                                         onPress={() => {
                                    //                                             NameHotspot = item.SSID
                                    //                                             this.ConnectWifiSSIDInternet()
                                    //                                             // this.setState({
                                    //                                             //         // addressMap: item.Address,
                                    //                                             //         listSearch: [],
                                    //                                             //         textInputSearch: ''
                                    //                                             //     },
                                    //                                             //     () => {
                                    //                                             //         // let idx = dataList.findIndex(obj => obj.id === item.id);
                                    //                                             //         //this.goNext(item, idx)
                                    //                                             //     })
                                    //
                                    //                                         }
                                    //                                         }
                                    //                                         style={{
                                    //                                             backgroundColor: Colors.light,
                                    //                                             // width: "100%",
                                    //                                             //         flex: 1,
                                    //                                             marginHorizontal: moderateScale(10),
                                    //                                             marginVertical: moderateScale(4),
                                    //                                             //  alignItems: 'center'
                                    //                                             //  marginVertical: moderateScale(2),
                                    //                                             // padding: moderateScale(6)
                                    //                                         }}>
                                    //
                                    //                                         <HMTextView
                                    //                                             // noFont={false}
                                    //                                             //  text={item.place_name}
                                    //                                             text={item.SSID}
                                    //                                             //  text={"dghd"}
                                    //                                             numberOfLines={1}
                                    //                                             style={{
                                    //                                                 fontSize: moderateScale(14),
                                    //                                                 // textAlign: 'right',
                                    //                                                 color: Colors.colorDark,
                                    //                                                 marginVertical: moderateScale(1)
                                    //                                             }}/>
                                    //                                         <View style={{
                                    //                                             width: '90%',
                                    //                                             alignSelf: 'center',
                                    //                                             marginTop: moderateScale(2),
                                    //                                             marginBottom: moderateScale(4),
                                    //                                             height: moderateScale(1),
                                    //                                             backgroundColor: Colors.light
                                    //                                         }}/>
                                    //                                     </TouchableOpacity>
                                    //                                 }
                                    //
                                    //
                                    //                             </View>
                                    //                         }
                                    //
                                    //                     />
                                    //
                                    //
                                    //             )
                                    //
                                    //
                                    //         }
                                    //
                                    //         {
                                    //
                                    //             <View
                                    //                 style={{
                                    //                     width: '100%',
                                    //                     height: moderateScale
                                    //                     (42),
                                    //                     flexDirection: 'row',
                                    //                     alignItems: 'center',
                                    //                     justifyContent: 'center',
                                    //                     marginBottom: moderateScale(3)
                                    //                 }}
                                    //             >
                                    //                 {
                                    //                     this.state.accessSearchWifi ?
                                    //
                                    //                         <TouchableOpacity
                                    //
                                    //                             onPress={() => {
                                    //
                                    //                                 this.ConnectWifiSSIDInternet();
                                    //                             }}
                                    //                             style={{
                                    //                                 flex: 1,
                                    //                                 height: moderateScale(42),
                                    //                                 alignItems: 'center',
                                    //                                 justifyContent: 'center',
                                    //                                 backgroundColor: Colors.colorPrimary,
                                    //                                 borderRadius: moderateScale(6)
                                    //                             }}>
                                    //                             <HMTextView
                                    //                                 //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    //                                 text={i18n.t('constant.ok')} type={"bold"}
                                    //                                 style={{
                                    //                                     fontSize: moderateScale(13),
                                    //                                     marginVertical: moderateScale(6),
                                    //                                     marginHorizontal: moderateScale(4),
                                    //                                     color: Colors.white
                                    //                                 }}/>
                                    //                         </TouchableOpacity>
                                    //                         :
                                    //
                                    //                         null
                                    //
                                    //                 }
                                    //
                                    //
                                    //                 <View style={{width: moderateScale(8)}}/>
                                    //                 <TouchableOpacity
                                    //                     onPress={
                                    //                         onPressCancel
                                    //                         // () => this.setState({
                                    //                         //     showDialog: false
                                    //                         // })
                                    //                         //this.props.onPressCancel
                                    //                         // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                    //                         //this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                    //
                                    //                         //this.goBack();
                                    //
                                    //                         //this.setState({showDialog: false})
                                    //                         //console.log(this.state)
                                    //                     }
                                    //                     style={{
                                    //                         flex: 1,
                                    //                         height: moderateScale(42),
                                    //                         alignItems: 'center',
                                    //                         justifyContent: 'center',
                                    //                         backgroundColor: Colors.colorPrimary,
                                    //                         borderRadius: moderateScale(6)
                                    //
                                    //                     }}>
                                    //
                                    //                     <HMTextView
                                    //                         //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                    //                         text={i18n.t('constant.Cancel')} type={"bold"}
                                    //                         style={{
                                    //                             fontSize: moderateScale(13),
                                    //                             marginVertical: moderateScale(6),
                                    //                             marginHorizontal: moderateScale(4),
                                    //                             color: Colors.white
                                    //                         }}/>
                                    //                 </TouchableOpacity>
                                    //             </View>
                                    //
                                    //         }
                                    //
                                    //
                                    //     </View>
                                    //     :
                                    <View>

                                        <HMTextView
                                            type={'bold'}
                                            style={{
                                                fontSize: moderateScale(14),
                                                color: Colors.blackLight,
                                                marginVertical: moderateScale(16),
                                            }}
                                            styleRoot={{alignSelf: 'center'}}
                                            text={!this.props.wifiIsEnabled ? "آیا میخواهید وای فای خود را روشن نمایید ؟" : (!this.props.wifiConnectionStatus ? this.state.textSearch : this.state.textSearch)}
                                            //text={global.MyVar}
                                        />

                                        {

                                            (this.state.loadingSearchWifi ?
                                                    <ActivityIndicator color={Colors.colorPrimary}
                                                                       size={"large"}/>
                                                    :

                                                    // null
                                                    (!this.state.accessSearchWifi ?
                                                        <FlatList
                                                            keyboardShouldPersistTaps="handled"
                                                            // ItemSeparatorComponent={
                                                            //     <View style={{
                                                            //         width: '100%',
                                                            //         height: moderateScale(1),
                                                            //         backgroundColor: '#4f4f4f'
                                                            //     }}/>
                                                            // }

                                                            style={{
                                                                height: typeExport._WIDTH / 2,
                                                                //  backgroundColor: Colors.light2,
                                                                //   marginBottom: moderateScale(50)
                                                            }}

                                                            data={this.state.listSearch}
                                                            //data={[1,2,3,4]}
                                                            //data={dataList}
                                                            keyExtractor={(item, index) => item.id}

                                                            renderItem={({item, index}) =>

                                                                <TouchableOpacity
                                                                    activeOpacity={.9}
                                                                    onPress={() => {
                                                                        this.setState({
                                                                                // addressMap: item.Address,
                                                                                // listSearch: [],
                                                                                textInputSearch: '',
                                                                                NameHotspot: item.SSID


                                                                            },
                                                                            () => {
                                                                                this.ConnectWifiSSIDInternet()

                                                                                // let idx = dataList.findIndex(obj => obj.id === item.id);
                                                                                //this.goNext(item, idx)
                                                                            })

                                                                    }
                                                                    }
                                                                    style={{
                                                                        backgroundColor: Colors.light,
                                                                        // width: "100%",
                                                                        //         flex: 1,
                                                                        marginHorizontal: moderateScale(10),
                                                                        //  alignItems: 'center'
                                                                        marginVertical: moderateScale(2),
                                                                        // padding: moderateScale(6)
                                                                    }}>

                                                                    <HMTextView
                                                                        // noFont={false}
                                                                        //  text={item.place_name}
                                                                        text={item.SSID ? item.SSID : item.subjects_tks_subject}
                                                                        //  text={"dghd"}
                                                                        numberOfLines={1}
                                                                        style={{
                                                                            fontSize: moderateScale(14),
                                                                            // textAlign: 'right',
                                                                            color: Colors.colorDark,
                                                                            marginVertical: moderateScale(1)
                                                                        }}/>
                                                                    <View style={{
                                                                        width: '90%',
                                                                        alignSelf: 'center',
                                                                        marginTop: moderateScale(2),
                                                                        marginBottom: moderateScale(4),
                                                                        height: moderateScale(1),
                                                                        backgroundColor: Colors.light
                                                                    }}/>
                                                                </TouchableOpacity>

                                                            }

                                                        />
                                                        :
                                                        null)


                                            )


                                        }

                                        {

                                            <View
                                                style={{
                                                    width: '100%',
                                                    height: moderateScale
                                                    (42),
                                                    flexDirection: 'row',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginBottom: moderateScale(3)
                                                }}
                                            >
                                                {
                                                    this.state.accessSearchWifi ?

                                                        <TouchableOpacity

                                                            onPress={() => {


                                                                if (this.props.wifiIsEnabled) {
                                                                    this.ConnectWifiSSIDInternet()
                                                                }

                                                                else {
                                                                    this.onWifi()

                                                                }

                                                            }}
                                                            style={{
                                                                flex: 1,
                                                                height: moderateScale(42),
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                backgroundColor: Colors.colorPrimary,
                                                                borderRadius: moderateScale(6)
                                                            }}>
                                                            <HMTextView
                                                                //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                                text={i18n.t('constant.ok')} type={"bold"}
                                                                style={{
                                                                    fontSize: moderateScale(13),
                                                                    marginVertical: moderateScale(6),
                                                                    marginHorizontal: moderateScale(4),
                                                                    color: Colors.white
                                                                }}/>
                                                        </TouchableOpacity>
                                                        :

                                                        null

                                                }


                                                <View style={{width: moderateScale(8)}}/>
                                                <TouchableOpacity
                                                    onPress={
                                                        onPressCancel
                                                        // () => this.setState({
                                                        //     showDialog: false
                                                        // })
                                                        //this.props.onPressCancel
                                                        // this.refs['viewPager'].setPage(this.state.currentPage - 1);
                                                        //this.refs['viewPager'].setPage(this.state.currentPage - 1);

                                                        //this.goBack();

                                                        //this.setState({showDialog: false})
                                                        //console.log(this.state)
                                                    }
                                                    style={{
                                                        flex: 1,
                                                        height: moderateScale(42),
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: Colors.colorPrimary,
                                                        borderRadius: moderateScale(6)

                                                    }}>

                                                    <HMTextView
                                                        //  text={" ( "+i18n.t('constant.optional')+ " ) "} type={"bold"}
                                                        text={i18n.t('constant.Cancel')} type={"bold"}
                                                        style={{
                                                            fontSize: moderateScale(13),
                                                            marginVertical: moderateScale(6),
                                                            marginHorizontal: moderateScale(4),
                                                            color: Colors.white
                                                        }}/>
                                                </TouchableOpacity>
                                            </View>

                                        }


                                    </View>
                            }


                        </View>

                    }
                </View>

                {

                    this.state.isLoading ?

                        <View
                            style={

                                {
                                    position: 'absolute',
                                    width: '100%',
                                    height: '100%',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    justifyContent: 'center',

                                    // height:"100%",
                                    // width:"100%",

                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0,
                                    backgroundColor: 'rgba(0,0,0,0.7)',
                                    // zIndex: 9900
                                }
                            }
                        >
                            <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>

                        </View>
                        :
                        null
                }

            </View>
            // : null


        );
    }

    onChangeText(name, text) {
        this.setState({[name]: text});
    }
}


const mapStateToProps = state => {
    return {
        DataSplashScreen: state.reducerSplashSatiaScreen,
        wifiIsEnabled: state.reducerSplashSatiaScreen.wifiIsEnabled,
        wifiConnectionStatus: state.reducerSplashSatiaScreen.wifiConnectionStatus,
        ConnectionInternetHotspot: state.reducerSplashSatiaScreen.ConnectionInternetHotspot,
        ConnectionType: state.reducerSplashSatiaScreen.ConnectionType,

    };
};
const mapDispatchToProps = dispatch => {
    return {
        //  setIsConnected: (data) => dispatch(serviceActionSetIsConnected(data)),
        // callServiceRtl: (data) => dispatch(serviceActionRtl(data)),

    }
};
export default connect(mapStateToProps, mapDispatchToProps)(HMDialogWifiCheck);

const styles = StyleSheet.create({
    modalBackDrop: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

        // height:"100%",
        // width:"100%",

        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 99999
    },
    modalDialog: {
        backgroundColor: "white",
        width: '85%',

        alignItems: 'center',
        justifyContent: 'center',
        padding: moderateScale(15),
        //    flex:1,

        // height: moderateScale(185),
        borderRadius: moderateScale(1),
        marginHorizontal: moderateScale(10),
    },
    modalLoading: {
        textAlign: "center",
    },

    modalTextTitle: {
        fontSize: moderateScale(16),
        color: 'black',
        //  fontFamily: "IRANSansMobile",
        justifyContent: 'center',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    modalTextDescription: {
        fontSize: moderateScale(14),
        // fontFamily: "IRANSansMobile",
        color: 'black',
        margin: 10
    },
    modalVeiwOk: {
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

    },
    modalTextName: {
        fontSize: moderateScale(16),
        color: 'black',
        // fontFamily: "IRANSansMobile",
        marginTop: moderateScale(6),
        marginBottom: moderateScale(6)
    },
    modalTextDesc: {
        fontSize: moderateScale(14),
        color: 'black',
        //fontFamily: "IRANSansMobile",
    },
    buttonShowStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginLeft: moderateScale(6),
        borderRadius: moderateScale(4),
        marginTop: moderateScale(10)

    }, buttonCancelStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginRight: moderateScale(6),
        borderRadius: moderateScale(4),
    }
});
